exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".verificationConfiguration .row .column .error label {\n  color: #c21807 !important;\n}\n.verificationConfiguration .row .column .error span {\n  margin-left: 8px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/verificationconfiguration/input.less
// module id = 2969
// module chunks = 0